import { render, staticRenderFns } from "./v-hkid-input.vue?vue&type=template&id=65599ff1&scoped=true&"
import script from "./v-hkid-input.vue?vue&type=script&lang=js&"
export * from "./v-hkid-input.vue?vue&type=script&lang=js&"
import style0 from "./v-hkid-input.vue?vue&type=style&index=0&id=65599ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65599ff1",
  null
  
)

export default component.exports